
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { QuestionProps } from '../../../typings/register';
import { RootState } from "../../../redux/store";
import EditTextField from '../../../components/EditTextField';
import { saveAboutMemberDescription } from '../../../services/memberService';
import { useHistory } from 'react-router-dom';
import QuestionUpdateHeader from './QuestionUpdateHeader';
import { GenderType } from '../../../helpers/Enums';


const UpdateAboutMeSentence = (props: any) => {
    const { value } = props.location.state;
    const [question, setQuestion] = useState<QuestionProps>();
    const { memberCode: myMemberCode, genderId: genderId } = useSelector((state: RootState) => state.member);

    let history = useHistory();

    const onSave = async (value: string) => {
        await saveAboutMemberDescription(myMemberCode, value);
        history.goBack();
    };


    const genderTitleText = () => {
        if (genderId === GenderType.MALE) {
            return "ספר קצת על עצמך ומה אתה מחפש";
        } else {
            return "ספרי קצת על עצמך ומה את מחפשת";
        }
    }

    return (
        <>
            <QuestionUpdateHeader />
            <EditTextField
                buttonText={"שמור"}
                subtitle={""}
                title={genderTitleText()}
                value={value ?? ""} onSave={onSave} />
        </>
    )
}

export default UpdateAboutMeSentence;


